/**
 * 기사관리 목록 (/adm/members)
 * ($j.Pages.Admin.MemberList / body data-page-name="MemberList")
 *
 * 구 `public/js/a-member-list.js` 를 번들로 흡수한 것. blade 에는 인라인 스크립트·onclick 이 없다 —
 * 버튼은 id 로 여기서 묶는다.
 *
 * 검색조건은 form(#forminput) → SEARCH 객체 → DataTables ajax 파라미터로 흐른다.
 * 표 렌더는 기사검색 모달과 공유하는 $j.F.Admin.Member.ListTable 가 맡는다.
 *
 * 검색칸 이름 (form#forminput) — 서버(MemberListService)가 같은 이름으로 받는다
 *   A~F 업종(스카이·사다리·크레인·지게차·굴삭기·리프트) · G 소유자만 · J -6차 · K 부재중 · M 서류 · L 테스트계정제외 (체크)
 *   bsanum/gsanum/cntnum 본사·지사·센터 → x1 소속(hidden)
 *   x2 서비스상태 · x3 회원유형 · x4 차고지 · x5 미접속 · xf 회비결제 · x6 기사코드 · x7 소유자코드
 *   x8 기사명(x8s 소속자 포함) · x9 전화번호 · xa 보유캐시 · xb 통합검색
 *   ct/cj/co/cr 장비 업종·전고·옵션·기종(hidden — 차량옵션 모달이 채운다)
 */
import Util from '../../Common/Util';
import LayoutData from '../../F/Admin/LayoutData';

export default class MemberList {
    constructor() {
        this.$table = null;
        this.CAR = {};      // 차량검색 조건 (모달이 돌려준 값)
    }

    initialize() {
        this.SEARCH = {};   // 검색조건 — form → 여기 → DataTables ajax 파라미터

        $('#mfExcel').on('click', () => { document.location.href = '/excel/member'; });
        $('#mfCashExcel').on('click', () => { document.location.href = '/excel/member/cash'; });
        $('#mfAdd').on('click', () => $j.F.Admin.Util.memberEdit(0, 'memberadd'));
        $('#forminput').on('submit', (e) => e.preventDefault());

        // 예전엔 blade 인라인이 initPage()·initHandler() 를 직접 불렀는데, 페이지모듈은
        // 비동기로 로드돼 그 시점을 못 맞춘다. 순서를 여기서 잡는다.
        this.initTable();
        this.initHandler();
    }

    initTable() {
        // 회원목록 DataTable 은 공용 모듈 (기사검색 모달과 컬럼 렌더 공유)
        this.$table = $j.F.Admin.Member.ListTable.create({
            selector:   '#table',
            getSearch:  () => this.SEARCH,     // 검색조건을 ajax 파라미터로 병합
            pageLength: 50,
            appVer:     LayoutData.get('appVer'),   // 버전컬럼 '최신' 판정 기준 (g5_apps JB — 레이아웃이 넘긴다)
        });
    }

    initHandler() {
        $j.Common.Form.registerPhoneHandler('x9');                                  // 전화번호
        $j.Common.Form.registerBonsaHandler('bsanum', 'gsanum', 'cntnum');          // 본사 <select>
        $j.Common.Form.registerGisaHandler('gsanum', 'cntnum');                     // 지사 <select>
        $j.Common.Form.updateBonsaSelectBox(null, 'bsanum', 'gsanum', 'cntnum');

        // 업종 체크박스 — 전체/개별
        $('#chk-all').on('click', (e) => this.checkCarTypes($(e.currentTarget).prop('checked')));
        $('#forminput input[type="checkbox"]').on('click', (e) => {
            if (!['A', 'B', 'C', 'D', 'E', 'F'].includes($(e.currentTarget).val())) return;
            $('#chk-all').prop('checked', false);
        });

        // 회비결제를 고르면 「소유자만검색」을 켠다 — 회비는 소유자 몫이라 소속자까지 나오면 같은 업체가 여러 줄로 보인다.
        // 끄는 것은 직원이 직접 한다(선택을 비워도 체크는 그대로 둔다)
        $('#forminput [name="xf"]').on('change', (e) => {
            if ($(e.currentTarget).val()) $('#forminput input[type="checkbox"][value="G"]').prop('checked', true);
        });

        // 검색칸에서 엔터 → 검색.
        //
        // ⚠ `input[type="text"]` 만 잡으면 안 된다. 전화번호칸이 `type="tel"` 이라 **그 칸만**
        //   엔터가 먹지 않았다. 폼이 `onsubmit="return false"` 라 브라우저 기본 제출도 없어서,
        //   아무 일도 안 일어나고 오류도 안 난다 — 조용히 안 되는 종류의 버그다.
        //   글자를 치는 칸은 앞으로도 늘어나므로(tel·search·number·email…) **아닌 것을 빼는**
        //   쪽으로 적고, 칸이 다시 그려져도 살아 있게 폼에 위임한다.
        $('#forminput').on('keydown',
            'input:not([type=checkbox]):not([type=radio]):not([type=hidden]):not([type=button]):not([type=submit])',
            (e) => { if (e.keyCode === 13) this.submit(); });

        // 기사명 검색 도움말 — 칸에 들어가면 아래에 띄우고 나오면 닫는다.
        // hover:true 는 팝오버가 마우스를 막지 않게 한다(바로 아래 표·버튼을 덮어도 눌린다).
        $('#forminput [name="x8"]')
            .on('focus', (e) => {
                if ($j.Ui.Tooltip.anchor === e.currentTarget) return;   // show 는 같은 요소면 토글로 닫는다
                $j.Ui.Tooltip.show(e.currentTarget, $('#nameSearchHelpTpl').html(), { title: '기사명 검색', hover: true });
            })
            .on('blur', (e) => { if ($j.Ui.Tooltip.anchor === e.currentTarget) $j.Ui.Tooltip.hide(); });

        // 기사명 '소속자 포함' 스위치 — 끄면 이름이 맞는 소유자만. 켜짐/꺼짐은 툴팁 문구로도 보인다
        $('#x8sub').on('click', (e) => {
            const on = !$(e.currentTarget).hasClass('is-on');
            $(e.currentTarget)
                .toggleClass('is-on', on)
                .attr('aria-checked', on)
                .attr('data-tip', on
                    ? '소속자 포함 — 소유자를 찾으면 그 소속자도 함께 나옵니다'
                    : '소유자만 — 이름이 맞는 소유자만 나옵니다 (눌러서 소속자 포함)');
            document.forminput.x8s.value = on ? '1' : '0';
        });

        // 통합검색 — 010 으로 치기 시작하면 로그인창처럼 대시를 붙인다.
        //   아이디가 010-xxxx-xxxx 로 저장돼 있어서다. 이름·상호를 칠 때는 건드리지 않는다
        $('#forminput [name="xb"]').on('keyup', (e) => {
            if (/^010[0-9-]*$/.test(e.currentTarget.value)) Util.phoneDashOnKey(e.currentTarget, e);
        });

        $('#searchBtn').on('click', () => this.submit());
        $('#car-range-select').on('click', () => this.openCarModal());

        // 통합검색어 하이라이트 — 표를 다시 그릴 때마다
        this.$table.on('draw.dt', () => this.highlight(document.forminput.xb.value));
    }

    /** 차량 검색 설정 — 기사검색 모달과 같은 공용 모달 */
    openCarModal() {
        const f = document.forminput;
        const put = (data) => {
            f.ct.value = data.car_type  || '';
            f.cr.value = data.car_range || '';
            f.cj.value = data.jungo     || '';
            f.co.value = data.option    || '';
        };

        $j.F.Admin.Member.CarSearchModal.open({
            car: this.CAR,
            onApply: (data) => {
                this.checkCarTypes(false, data.car_type);   // 고른 기종의 업종 체크박스 동기화
                $('.bx-badge-memo').html($j.F.Admin.Member.CarSearchModal.memo(data)).show();
                put(data);
                this.CAR = data;
                this.submit();
            },
            onClear: () => {
                this.checkCarTypes(false);
                $('.bx-badge-memo').html('').hide();
                put({});
                this.CAR = {};
                this.submit();
            },
        });
    }

    /**
     * 스카이~리프트 체크박스 일괄 제어.
     * @param chk  true 전부체크 / false 전부해제
     * @param only 한글 업종명이 오면 그것만 체크 (예: '스카이')
     */
    checkCarTypes(chk, only = '') {
        ['A', 'B', 'C', 'D', 'E', 'F'].forEach((v) => {
            $(`input[type="checkbox"][value="${v}"]`).prop('checked', chk);
        });
        if (only) $(`input[type="checkbox"][data-value="${only}"]`).prop('checked', true);
    }

    /** 통합검색어를 표 안에서 붉게 표시 */
    highlight(keyword) {
        if (!keyword) return;
        const pattern = new RegExp(keyword, 'g');
        $('#table').find(':not(iframe, script, style)').addBack().contents()
            .filter(function () { return this.nodeType === 3 && this.nodeValue.trim() !== ''; })
            .each(function () {
                $(this).replaceWith(this.nodeValue.replace(pattern, (m) => `<span style="color:#e5156c">${m}</span>`));
            });
    }

    /** form → SEARCH → DataTables 재조회 */
    submit() {
        const f = document.forminput;

        f.opt.value = $(f).find('input[type="checkbox"]:checked')
            .map(function () { return this.value; }).get().join('');

        // 소속 — 센터 > 지사 > 본사 우선
        f.x1.value = $('#cntnum').val() || $('#gsanum').val() || $('#bsanum').val() || '';

        $(f).serializeArray().forEach((item) => { this.SEARCH[item.name] = item.value; });
        this.$table.ajax.reload();

        // 기사명 칸에서 엔터로 검색하면 포커스가 칸에 남아 도움말이 결과를 가린다 — 검색했으면 접는다
        if ($j.Ui.Tooltip.anchor === f.x8) $j.Ui.Tooltip.hide();
    }
}
